import { useState } from "react";
import { Alert, Button, ConfigProvider, DatePicker, Modal, Select } from "antd";
import { Box, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import ptBR from 'antd/lib/locale/pt_BR';
import { Method_POST } from "../../../../../../../service/api";
import { toast } from "react-toastify";


export function MigrarEmpresa({ info, dados, numeroSolicitacao, setIsModalDataMigracao, fetchData }) {
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [modalAlert, setModalAlert] = useState(false);
  const [selectedValue, setSelectedValue] = useState(dados.empresa.regimeTributario?.id);
  const [data, setData] = useState(info.dataMigracao ? dayjs(info.dataMigracao) : dayjs());

  const onChange = (date, dateString) => {
    setData(date);
  };

  const handleChange = (value) => {
    setModalAlert(true);
    setSelectedValue(value);
    setHasError(false);
  };

  const calcular = async () => {
    try {
      const url = `/ordem-servico/assinatura/calcular`;

      const payload = {
        dataCriacao: info.dataCriacao,
        dataSituacao: info.dataSituacao,
        empresa: {
          faturamento: info.faturamento,
          regimeTributario: {
            id: "LP",
          },
          segmento: {},
          simplesNacional: info.simplesNacional,
          tipo: {},
        },
        situacao: {
          id: "",
        },
        tipo: {
          id: "",
        },
      };

      const response = await Method_POST(url, payload);

      if (response) {
        setModalAlert(false)
      } else {
        throw new Error("Nenhuma ação foi feita pela API");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }

  const atualizar = async () => {
    if (selectedValue === "") {
      toast.info("Selecione o Regime Tributário");
      setHasError(true);
      return;
    } else {
      setHasError(false);
    }

    if (data === "") {
      toast.info("Selecione a data de migração");
      return;
    }

    setLoading(true);

    try {
      const url = `/ordem-servico/empresa/migracao/atualizar`;
      const dataFormatada = new Date(data).toISOString();

      const payload = {
        dataMigracao: dataFormatada,
        id: numeroSolicitacao,
        regimeTributario: {
          id: selectedValue,
        },
      };

      const response = await Method_POST(url, payload);

      if (response) {
        toast.success("Atualização feita com sucesso!");
        fetchData();
        setIsModalDataMigracao(false);
      } else {
        throw new Error("Nenhuma ação foi feita pela API");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div style={{ marginBottom: 15 }}>
        <Alert
          message="Atenção"
          description="É necessário preencher a data de alteração de enquadramento da empresa para prosseguir."
          type="warning"
          showIcon
        />

      </div>


      {loading ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <div style={{ display: "flex" }}>
            <div style={{ margin: "0 5px" }}>
              <div>Data Migração</div>

              <ConfigProvider locale={ptBR}>
                <DatePicker
                  onChange={onChange}
                  style={{ width: 200 }}
                  value={data}
                  format="DD/MM/YYYY"
                />
              </ConfigProvider>
            </div>
            <div>
              <div>Regime Tributário</div>

              <Select
                value={selectedValue}
                onChange={handleChange}
                status={hasError ? 'error' : ''}
                style={{
                  width: 260,
                }}
                options={[
                  {
                    value: "SIMEI",
                    label: "SIMEI - Sistema de Recolhimento MEI",
                  },
                  {
                    value: "SN",
                    label: "SN - Simples Nacional",
                  },
                  {
                    value: "LP",
                    label: "LP - Lucro Presumido",
                  },
                  {
                    value: "LR",
                    label: "LR - Lucro Real",

                  },
                  {
                    value: "",
                    label: "Selecionar",
                    disabled: true,
                  }
                ]}
              />
            </div>
          </div>

          <br />
          <div>
            <Button type="primary" loading={loading} onClick={atualizar} disabled={loading}>
              Salvar
            </Button>
          </div>
        </>
      )}



      {modalAlert && (
        <Modal
          title="Confirmação"
          open={modalAlert}
          onOk={calcular}
          onCancel={() => setModalAlert(false)}
          okText="Sim"
          cancelText="Não"
        >
          <p>
            Alteração do segmento de atuação ou do regime tributário da empresa
            implicará na atualização do valor da assinatura da mensalidade.
          </p>
          <p>
            <strong>Deseja atualizar o valor da mensalidade?</strong>
          </p>
          <Alert
            message="Atenção"
            description="Será necessário
              salvar os dados do cliente para gravar o novo valor da mensalidade
              dos serviços."
            type="warning"
            showIcon
          />
        </Modal>
      )}
    </>
  );
}

export default MigrarEmpresa;
